import { Chip, ChipProps, chipClasses, styled } from "@mui/material";
import { forwardRef } from "react";

export interface AppChipProps extends ChipProps {
  /** Round is for icons, counters, etc. */
  shape?: "square" | "round";
}

const ChipStyled = styled(Chip, {
  // shouldForwardProp: (prop) => prop !== "active", // prevent custom `active` prop from being passed to DOM
})<AppChipProps>(({ theme, shape }) => ({
  ...(shape === "square" && {}),
  ...(shape === "round" && {
    [`& .${chipClasses.label}`]: {
      // padding: 0,
    },
  }),
}));

export default forwardRef<HTMLDivElement, AppChipProps>(function AppChip(
  { shape = "square", sx, ...otherProps }: AppChipProps,
  ref,
) {
  return (
    <ChipStyled
      ref={ref}
      sx={{
        ...sx,
      }}
      shape={shape}
      {...otherProps}
    />
  );
});
